import CircularProgress from "@mui/material/CircularProgress";
import { ReactComponent as AddIcon } from "assets/icons/add-plus.svg";
import React, { useState } from "react";

const AchCardList = ({ setSelectedAchCard, selectedAchCard, cardList }) => {
  const [cardLoading] = useState(false);

  return (
    <div className="card_num_field">
      {cardLoading ? (
        <div className="text-center">
          <CircularProgress />
        </div>
      ) : (
        <>
          {!!cardList?.length && !cardLoading ? (
            <div
              className="cards-radio font-16 d-flex flex-column items-center "
              style={{
                gap: "10px",
                width: "max-content",
              }}
            >
              {cardList?.map((item, index) => (
                <div
                  data-id={item.id}
                  key={item.id}
                  onClick={() => {
                    if (selectedAchCard === item.id) {
                      setSelectedAchCard("");
                    } else {
                      setSelectedAchCard(item.id);
                    }
                  }}
                  style={{
                    width: "100%",
                    color: selectedAchCard !== item.id ? "#2a2a2ab3" : "#000",
                  }}
                >
                  <p className="justify-content-between">
                    {`${item.nameOnAccount ? item.nameOnAccount : ""} ${
                      item.accountNumber ? "/ " + item.accountNumber : ""
                    }`}
                    <div
                      className="checkbox checkbox-lg checkbox-single"
                      style={{ margin: "0 !important" }}
                    >
                      <input
                        type="checkbox"
                        name={`card_number${index}`}
                        id={index}
                        onChange={(e) => {
                          setSelectedAchCard(e.target?.checked ? item?.id : "");
                        }}
                        checked={selectedAchCard === item?.id}
                      />
                      <span />
                    </div>
                  </p>
                </div>
              ))}
            </div>
          ) : (
            <div className="add-new-payment-info my-5">
              <span className="add-icon">
                <AddIcon />
              </span>
              <span className="add">Add ACH account</span>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default AchCardList;
